import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { SpxLaunch } from "../../data/spx-launch";

@Component({
  selector: "upcoming-launch-card",
  templateUrl: "./upcoming-launch-card.component.html",
  styleUrls: ["./upcoming-launch-card.component.scss", "./upcoming-launch-card.component.mobile.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpcomingLaunchCard {
  @Input()
  public launch: SpxLaunch;

  @Input()
  public photoUrl: string;
}
